export const DIGITAL_TEAM_EMAIL_PATTERN = /@([a-z0-9-]+\.)*consultdss\.com$/i

export function isDigitalTeamEmail(email) {
  return DIGITAL_TEAM_EMAIL_PATTERN.test(String(email ?? '').trim())
}
